<template>
  <Avatar :label="initials" :style="{ backgroundColor: bgColor }" />
</template>

<script setup>
import Avatar from 'primevue/avatar';
import { computed } from 'vue';

const props = defineProps({
  name: String,
});

const initials = computed(() => {
  const nameParts = props.name.split(' ');
  return `${nameParts[0][0]}${nameParts[1][0]}`.toUpperCase();
});

const bgColor = computed(() => {
  const generateColorHsl = id => {
    const getHashOfString = str => {
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      hash = Math.abs(hash);
      return hash;
    };

    const normalizeHash = (hash, min, max) => {
      return Math.floor((hash % (max - min)) + min);
    };

    const generateHSL = name => {
      const hash = getHashOfString(name);
      const h = normalizeHash(hash, 0, 360);
      const s = normalizeHash(hash, 10, 40);
      const l = normalizeHash(hash, 50, 75);
      return [h, s, l];
    };

    const HSLtoString = hsl => {
      return `hsl(${hsl[0]}, ${hsl[1]}%, ${hsl[2]}%)`;
    };

    return HSLtoString(generateHSL(id));
  };

  return generateColorHsl(props.name);
});
</script>
